import { Calculation, CurrencyExchangeDetails, ExchangeDirection } from 'models/exchange-transfer-calculate'
import { Language } from 'utils/current-language'
import { CurrencyMinimalAmount, SettingsKeys } from 'models/settings'

export const SETTINGS_KEYS: SettingsKeys[] = ['currency', 'market-currency-pairs', 'direct-exchange-minimal-amounts']
export const ALLOWED_WALUTOMAT_HOSTS = ['www.walutomat.pl', 'www.walutomat.com']
export const FIXED_OPTION_LIST: ExchangeDirection[] = ['back', 'forward']

export const AUTH_TOKEN =
  'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoibW9qYW5vcndlZ2lhIiwiaWF0IjoxNzUwMDY5OTM5fQ.1aY6KZGtu6mJR_ofsdE6Dtwjb9KHYRI0w73FLHym8xk'

export const DISCOUNT_RATE = 0.5
export const DEFAULT_BASE_AMOUNT = '100.00'
export const DEFAULT_COUNTER_AMOUNT = undefined
export const DEFAULT_BASE_CURRENCY = 'EUR'
export const DEFAULT_COUNTER_CURRENCY = 'PLN'
export const DEFAULT_DIRECTION: ExchangeDirection = 'forward'

export const DEFAULT_DEBOUNCE_TIME = 300
export const DEFAULT_REFRESH_TIME = 10 * 1000

// for partner customization
export const DEFAULT_LANGUAGE: Language = 'pl'
export const DEFAULT_CTA_HREF = 'https://www.walutomat.pl/landing/wymiana/'
export const DEFAULT_DARK_MODE_OPTION = false

export const DEFAULT_EXCHANGE_DATA: CurrencyExchangeDetails = {
  baseAmount: DEFAULT_BASE_AMOUNT,
  counterAmount: DEFAULT_COUNTER_AMOUNT,
  baseCurrency: DEFAULT_BASE_CURRENCY,
  counterCurrency: DEFAULT_COUNTER_CURRENCY,
  direction: DEFAULT_DIRECTION,
  discountRate: DISCOUNT_RATE,
  headers: {
    authorization: AUTH_TOKEN,
  },
}

export const DEFAULT_RESPONSE: Calculation = {
  sold_amount: '0.00',
  bought_amount: '0.00',
  exchange_amount: '0.00',
  bought_currency: 'NOK',
  sold_currency: 'PLN',
  average_rate: '0.0000',
  transfer_type: 'ELIXIR',
  transfer_type_fee: '0.00 PLN',
  minimal_amount: '0.00 PLN',
  fee_amount: '0.00',
  fee_percent: '0.00',
  base_currency: 'PLN',
  fee: '0.00',
}

export const DEFAULT_MINIMAL_AMOUNT: CurrencyMinimalAmount = {
  currency: 'EUR',
  minimal_local: '1',
  minimal_foreign: '1',
  minimal_wallet: '1',
}
